<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>アクセス管理</template>
      <template #right>
        <RouterLink
          :to="{
            name: 'authzPolicySettingNew',
            params: {
              entranceGUID: entranceGUID,
            },
          }"
        >
          <FlatButton>新規作成</FlatButton>
        </RouterLink>
      </template>
    </SettingsPagePanelHeader>
    <ul :class="$style.list">
      <li
        v-for="policy in policies"
        :key="policy.guid"
        :class="$style.list__item"
      >
        <router-link
          :to="{
            name: 'authzPolicySettingDetail',
            params: {
              authzPolicySettingGuid: policy.guid,
              entranceGUID: entranceGUID,
            },
          }"
          :class="$style.listItem"
        >
          <p>{{ policy.name }}</p>
        </router-link>
      </li>
    </ul>
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import FlatButton from '@/components/atoms/FlatButton.vue'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { useSettingsPageAuthzPolicyViewQuery } from './SettingsPageAuthzPolicyView.generated'

const route = useRoute('authzPolicySetting')
const entranceGUID = computed(() => route.params.entranceGUID)

const { result } = useSettingsPageAuthzPolicyViewQuery({
  fetchPolicy: 'no-cache',
})

const policies = computed(() => {
  // TODO: gqlを修正すればfilter不要
  return result.value?.authzPolicies.filter(policy => policy !== null)
})
</script>

<style lang="scss" module>
.list {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &:nth-child(n + 2) {
    margin-top: 12px;
  }

  &__item {
    border: 1px solid $color-border-low-emphasis;
    border-radius: $border-radius-v2-base;
    padding: 16px;

    &:hover {
      background-color: $color-surface-accent-primary-light;
    }
  }
}

.listItem {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
</style>
